import { settings } from "@/settings";
const state = {
  appName: settings.APP_NAME,
  clubName: settings.CLUB_NAME,
  clubNameShort: settings.CLUB_NAME_SHORT,
  clubId: settings.CLUB_ID,
};

const getters = {
  appName: (state) => state.appName,
  clubName: (state) => state.clubName,
  clubNameShort: (state) => state.clubNameShort,
  clubId: (state) => state.clubId,
};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
